import * as THREE from "three";

function getMapCameraOrientation({ cameraForward, cameraUp }: { cameraForward: THREE.Vector3; cameraUp: THREE.Vector3 }) {
	const pitchDeg = Math.acos(THREE.MathUtils.clamp(-cameraForward.y, -1, 1)) * THREE.MathUtils.RAD2DEG;
	const bearingDeg = -Math.atan2(cameraForward.x, cameraForward.z) * THREE.MathUtils.RAD2DEG;

	const worldUp = new THREE.Vector3(0, 1, 0);
	const right = new THREE.Vector3().crossVectors(cameraForward, worldUp).normalize();
	const expectedUp = new THREE.Vector3().crossVectors(right, cameraForward).normalize();
	const rollRad = Math.atan2(cameraUp.dot(right), cameraUp.dot(expectedUp));
	const rollDeg = THREE.MathUtils.radToDeg(rollRad);

	return { pitchDeg, bearingDeg, rollDeg };
}

export { getMapCameraOrientation };
